import { useCallback, useEffect } from 'react'

import { setPaymentMethod } from 'src/Redux/payment-process'
import { PaymentMethodEnum } from 'src/Constants/enums'

import { useAppDispatch } from './redux'

type DefaultPaymentMethodOptions = {
  isEnoughBalance?: boolean
  hasBillingData?: boolean
  isMetaUrl?: boolean
}

export const useDefaultPaymentMethod = (
  options: DefaultPaymentMethodOptions,
): void => {
  const { isEnoughBalance, hasBillingData, isMetaUrl } = options
  const dispatch = useAppDispatch()

  const getDefaultValue = useCallback(() => {
    if (isEnoughBalance) {
      dispatch(setPaymentMethod(PaymentMethodEnum.Credits))
      return
    }
    if (hasBillingData && !isMetaUrl) {
      dispatch(setPaymentMethod(PaymentMethodEnum.PAYPAL_BILLING_AGREEMENT))
      return
    }
    dispatch(setPaymentMethod(PaymentMethodEnum.STRIPE))
  }, [isEnoughBalance, hasBillingData, isMetaUrl, dispatch])

  useEffect(() => {
    getDefaultValue()
  }, [getDefaultValue])
}
